import React from 'react';

import * as S from './CaptivateBannerGalleryWithVideo.styles';

import ImageItem from './ImageItem';

const ImageCategory = ({categories, isSeoPage, customStyles = {}}) => {
  return (
    <S.ImageRightSectionWrapper width={!categories?.length ? '232px' : null}>
      {categories?.map(category => (
        <ImageItem
          {...category}
          isSeoPage={isSeoPage}
          imageHeight={customStyles?.imageHeight}
          marginBottom={customStyles?.marginBottom}
        />
      ))}
    </S.ImageRightSectionWrapper>
  );
};

export default ImageCategory;
